import { createReducer, on } from '@ngrx/store';
import { setAlertObject } from './alert-object.actions';
export const alertObject = createReducer(undefined, on(setAlertObject, (state, action) => {
    return action.alertObject;
}));
